
























































import DocModal from '../../../console/business-data/Product/components/DocModal.vue'
import {
  ProductionPlanServiceProxy,
  ProductionPlanProcessServiceProxy,
  AdditionPlanDTO,
  FileInfoDetailDTO,
  FileDetailInfoVO
} from '@/service-proxies/app-v2/coproduction.service-proxies'
import {
  ProductServiceProxy,
  ProductionCraftServiceProxy
} from '@/service-proxies/app-v2/product.service-proxies'
import Vue from 'vue'
import moment from 'moment'
import { isDisplayShow } from '@/utils/index'
import WorkingProcedure from './WorkingProcedure.vue'
import { BomVersionServiceProxy } from '@/service-proxies/app-v2/material.service-proxies'
import { CustomerServiceProxy } from '@/service-proxies/app-v2/client.service-proxies'
import { CodeRuleServiceProxy } from '@/service-proxies/app-v2/code.service-proxies'
import { ProductionPlanTypeServiceProxy } from '@/service-proxies/app-v2/coproduction.service-proxies'
const productionPlanServiceProxy = new ProductionPlanServiceProxy()
const productServiceProxy = new ProductServiceProxy()
const productionCraftServiceProxy = new ProductionCraftServiceProxy()
const productionPlanProcessServiceProxy = new ProductionPlanProcessServiceProxy()
const bomVersionServiceProxy = new BomVersionServiceProxy()
const customerServiceProxy = new CustomerServiceProxy()
const crsp = new CodeRuleServiceProxy()
const pptsp = new ProductionPlanTypeServiceProxy()
export default Vue.extend({
  components: {
    WorkingProcedure,
    DocModal
  },
  data() {
    return {
      title: this.$t('page_plan_add'),
      typeId: this.$route.path[this.$route.path.length - 1],
      category: 1,
      categoryList: [
        {
          label: this.$t('page_plan_production_plan'),
          value: 1
        },
        {
          label: this.$t('page_plan_incoming_materials'),
          value: 2
        }
      ],
      workProcedureList: [],
      productList: [],
      formProductList: [],
      craftList: [],
      formCraftList: [],
      chooseIndex: 0,
      editCol: '',
      schema: {},
      hasInitSchema: false,
      docModalVisible: false,
      // 用于展示程序列表下拉
      fileList: [],
      // 用于来料计划往后台传参
      fileList4NewIncomming: [],
      bomVersionList: [],
      customerList: [],
      formBomVersionList: [],
      formCustomerList: [],
      saveLoading: false,
      planList: [],
      showDisabled: false,
      current: 1,
      pageSize: 999,
      productListForm: []
    }
  },
  created() {
    this.getCodeRules()
    customerServiceProxy.getPageCustomer(undefined,1, '', 999).then((res) => {
      this.customerList = res.records
      this.formCustomerList = this.customerList.map((re) => {
        return {
          label: re.name,
          value: re.name
        }
      })
    })
    if (this.isEdit || this.addFlag) {
      this.formData.planStartTime = this.covertTime2Date(this.formData.planStartTime)
      this.formData.planEndTime = this.covertTime2Date(this.formData.planEndTime)
      this.category = this.formData.category
      if (this.addFlag) {
        productionPlanProcessServiceProxy.getProductionProcessList(this.formData.id).then((res) => {
          this.workProcedureList = res
        })
      } else {
        // 来料
        productionPlanServiceProxy.getIncomingPlan(this.formData.id).then((res) => {
          this.workProcedureList = res.list
          this.formData.resourceId = res.resourceId
          this.initSchema()
          if (this.formData.resourceId && this.formData.category === 2) {
            productionCraftServiceProxy
              .getResourceFileList(this.formData.resourceId)
              .then((res) => {
                this.fileList = res
              })
            productionPlanServiceProxy
              .getResourceFile(this.formData.resourceId)
              .then((res: FileDetailInfoVO[]) => {
                this.fileList4NewIncomming = []
                res.forEach((re) => {
                  this.fileList4NewIncomming.push(
                    new FileInfoDetailDTO({
                      contentLength: re.contentLength,
                      contentType: re.contentType,
                      contentMd5: re.contentMd5,
                      displayName: re.displayName,
                      fileType: re.fileType,
                      objectKey: re.objectKey,
                      suffix: re.suffix
                    })
                  )
                })
              })
          }
        })
      }
    }
    this.title = this.addFlag ? this.$t('page_plan_add_plan') : (this.isEdit ? this.$t('page_plan_edit_plan') : this.$t('page_plan_add'))
    if (!this.addFlag && this.productTypeList && this.productTypeList.length) {
      this.initSchema()
      if(this.category === 1){
        productServiceProxy
        .getFixedBoardList(this.productTypeList[0].value)
        .then((res) => {
          this.productList = res
          this.productListForm = res.map((item) => {
            return {
              label: item.code +'—'+ item.name,
              value: item.code
            }
          })

          if (this.formData.productId) {
            this.getCraftListByProductId(this.formData.productId)
          }
          if (this.formData.craftId) {
            this.getBomVersionByCraftId(this.formData.craftId)
          }
        })
        .catch((res) => {
          this.category = 2
          this.initSchema()
        })
      }
    } else {
      this.initSchema()
    }
  },
  computed: {
    isEdit() {
      return Object.keys(this.formData).length > 0 && !this.addFlag
    }
  },
  props: {
    formData: {
      type: Object,
      default: () => ({})
    },
    // 是否为追加
    addFlag: {
      type: Boolean,
      default: false
    },
    columns: {
      type: Array,
      default: () => []
    },
    productTypeList: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    initSchema() {
      const readOnlyCodes = ['materialCode', 'productName', 'productCode']
      if (this.addFlag) {
          readOnlyCodes.push(
          'orderCode',
          'productTypeName',
          // 'productCode',
          'category',
          'craftVersion',
          'codeAndName'
        )
      }
      if (this.isEdit) {
        if (this.formData.planStatus !== 1) {
          // 加工中的只保留数量可编辑
          for (const key in this.formData) {
            if (key !== 'planNum' && key !== 'orderCode') {
              readOnlyCodes.push(key)
            }
          }
        } else {
          readOnlyCodes.push('code', 'productTypeName', 'productCode', 'category')
        }
      }
      this.schema = { properties: {}, required: [] }
      if (this.title === '新建计划') {
        if (this.columns.every((item) => item.code !== 'codeRuleId')) {
          this.columns.unshift({
            bizCode: 'plan',
            code: 'codeRuleId',
            id: 1734567908635,
            isDisplay: 1,
            isRequired: 0,
            isSystem: 1,
            sort: 0,
            tip: '请选择编码规则',
            title: '编码规则 ',
            type: 1
          },
          )
        }
      }
      if(!this.isEdit) {
          if (this.columns.every((item) => item.code !== 'codeAndName')) {
             this.columns.splice(4,0, {
            bizCode: 'plan',
            code: 'codeAndName',
            id: 1734567908639,
            isDisplay: 1,
            isRequired: 1,
            isSystem: 1,
            sort: 5,
            tip: '请选择产品',
            title: '产品信息 ',
            type: 1
          },
          )
        }
      }

      if (this.title === '编辑计划') {
        this.columns.map((item, index) => {
          if (item.code === 'codeRuleId') {
            this.columns.splice(index, 1)
          }
        })
      }
      this.columns.map((item) => {
        if (this.itemCanShow(item)) {
          this.schema.properties[item.code] = {
            title: item.title,
            ui: {
              widget: this.getWidget(item.code),
              placeholder: item.tip,
              showTime: false,
              requiredMessage: item.tip,
              min: 1,
              max: 999999,
              showSearch: true,
              disabledDate: (current) => {
                return current && current < moment().startOf('day')
              }
            },
            default: this.getDefault(item.code),
            enum: this.getEnum(item.code)
          }
          if (readOnlyCodes.includes(item.code)) {
            this.schema.properties[item.code].readOnly = true
          }
          if (item.isRequired) {
            this.schema.required.push(item.code)
            if(this.category!==1){
              this.schema.required.map((item,index)=>{
                if(["codeAndName","productCode","productName","productTypeName"].includes(item)){
                  this.schema.required.splice(index,1)
                }
              })
            }

          }
          if (item.code === 'code') {
            this.schema.properties[item.code].maxLength = 32
          }
          if (item.code === 'orderCode') {
            this.schema.properties[item.code].maxLength = 100
          }
          if (item.code === 'codeRuleId') {
            this.schema.properties[item.code].ui.allowClear = true
          }
        }
      })
      if (this.isEdit || this.addFlag) {
        for (let key in this.schema.properties) {
          this.schema.properties[key].default = this.formData[key] ? this.formData[key] : ''
        }
        // if(this.addFlag) {
          if (this.schema.properties['codeAndName']) {
            this.schema.properties['codeAndName'].default =
            this.formData['productCode'] ? this.formData['productCode'] : '' +
            (this.formData['productCode'] && this.formData['productName'] ? '-': '') +
            this.formData['productName'] ? this.formData['productName'] : ''
          }
        // }

      }
      this.hasInitSchema = true
    },
    async getCodeRules() {
      const res = await crsp.list('PlanObject')
      let arr = []
      arr = res
      for (const k of arr) {
        this.planList.push({
          label: k.name,
          value: k.id
        })
      }
    },
    itemCanShow(item) {
      let flag = true
      if (!isDisplayShow(item.isDisplay, 1)) {
        return false
      }
      // 产品相关的隐藏
      const productArr = [
        'craftVersion',
        'bomVersion'
      ]
      if (this.category === 2 && productArr.includes(item.code)) {
        const ele = this.$refs.dForm
        const val = ele && ele.form ? ele.form.getFieldValue('codeRuleId') : ''
        if (val) {
          this.schema = {
            ...this.schema,
            properties: {
              ...this.schema.properties,
              code: {
                ...this.schema.properties.code,
                readOnly: true
              }
            }
          }
        }
        return false
      } else {
        if (this.category === 1) {
          if (this.$refs.dForm) {
            const { form } = this.$refs.dForm
            const val = form.getFieldValue('codeRuleId')
            if (val) {
              this.schema = {
                ...this.schema,
                properties: {
                  ...this.schema.properties,
                  codeRuleId: {
                    ...this.schema.properties.codeRuleId,
                    default: val
                  },
                  code: {
                    ...this.schema.properties.code,
                    readOnly: true
                  }
                }
              }
            }
          }
        }
      }
      return true
    },
    handleCancel() {
      this.$emit('closeModal', false)
    },
    getDefault(code) {
      if (code === 'category') {
        return this.category
      }
      if (code === 'input-number') {
        return '1'
      }
      if (code === 'productTypeName' && this.productTypeList && this.productTypeList.length) {
        this.getProductInfoList({
          key: "productTypeName",
          value: this.productTypeList[0].value
        })
        return this.productTypeList[0].value
      }
    },
    getEnum(code) {
      const obj = {
        category: this.categoryList,
        // productCode: this.productListForm,
        craftVersion: this.formCraftList,
        bomVersion: this.formBomVersionList,
        customerName: this.formCustomerList,
        codeRuleId: this.planList,
        productTypeName: this.productTypeList,
        codeAndName: this.productListForm
      }
      return obj[code]
    },
    getWidget(code) {
      if (code === 'category') {
        return 'radio'
      }
      // code === 'productCode' ||
      if (
        code === 'craftVersion' ||
        code === 'bomVersion' ||
        code === 'customerName' ||
        code === 'codeRuleId' ||
        code === 'productTypeName'||
        code === 'codeAndName'
      ) {
        return 'select'
      }
      if (code === 'planStartTime' || code === 'planEndTime') {
        return 'date'
      }
      if (code === 'planNum') {
        return 'input-number'
      }
      return 'input'
    },
    // flag为true 是保存并编辑工艺，这时不要关闭弹窗
    handleOk(flag) {
      if (this.editCol !== '' && this.category === 2) {
        this.$message.error(this.$t('page_plan_add_tip'))
        return
      }
      const { form } = this.$refs.dForm
      form.validateFields(async (err, values) => {
        if (!err) {
          values.planStartTime = this.covertTime2String(values.planStartTime)
          values.planEndTime = this.covertTime2String(values.planEndTime)
          if (values.planStartTime > values.planEndTime) {
            this.$message.error(this.$t('page_plan_time_tip'))
            return
          }
          this.saveLoading = true
          values.typeId = this.typeId
          if (values.productCode) {
            const product = this.productList.find((res) => res.code === values.productCode) || {}
            values.productId = product.id
          }
          if (values.craftVersion) {
            const craft = this.craftList.find((res) => res.version === values.craftVersion) || {}
            values.craftId = craft.id
            values.resourceId = craft.resourceId
          }
          if (values.bomVersion) {
            const bom = this.bomVersionList.find((res) => res.version === values.bomVersion) || {}
            values.bomId = bom.id
            values.bomVersion = bom.version
          }
          if (values.customerName) {
            const customer = this.customerList.find((res) => res.name === values.customerName)
            values.customerId = customer.id
            values.customerName = customer.name
          }
          if (values.productTypeName) {
            const productType =
              this.productTypeList.find((res) => res.value === values.productTypeName) || {}
            values.productTypeName = productType.label
            values.productTypeId = productType.value
          }

          if (this.isEdit) {
            values.id = this.formData.id
          }
          if (this.addFlag) {
            // 追加计划
            productionPlanServiceProxy
              .additionalPlan(
                {
                  code: values.code,
                  planEndTime: values.planEndTime,
                  planNum: values.planNum,
                  planStartTime: values.planStartTime,
                  selectStartProcessIndex: this.chooseIndex
                } as AdditionPlanDTO,
                this.formData.id
              )
              .then((res) => {
                this.success()
                this.saveLoading = false
              }).catch(() => {
                this.saveLoading = false
              })
          } else if (values.category === 2) {
            // 来料的新建和编辑
            values.list = this.workProcedureList
            values.list.forEach((res) => {
              delete res.editable
              delete res.id
            })
            values.fileList = []
            // 上传过工艺文档
            this.fileList4NewIncomming.forEach((res) => {
              values.fileList.push(new FileInfoDetailDTO(res))
            })
            productionPlanServiceProxy
              .saveInComingPlan(values)
              .then((res) => {
                let id = flag ? res : ''
                this.success(id)
                this.saveLoading = false
              })
              .catch(() => {
                this.saveLoading = false
              })
          } else if (this.isEdit) {
            // 生产计划的编辑
            values.productCode = this.formData.productCode
            values.productName = this.formData.productName
            productionPlanServiceProxy
              .update(values)
              .then((res) => {
                this.success()
                this.saveLoading = false
              })
              .catch(() => {
                this.saveLoading = false
              })
          } else {
            // 生产计划的新建
            const data = await pptsp.getProductionPlanTypeInfo()
            data.map((item) => {
              if (values.typeId == item.id) {
                values.typeName = item.name
              }
            })
            this.productList.map(item => {
              if(item.code === values.codeAndName) {
                values.productCode = item.code
                values.productName = item.name
              }
            })
            delete values.codeAndName
            delete values.list
            productionPlanServiceProxy
              .save(values)
              .then((res) => {
                this.success()
                this.saveLoading = false
              })
              .catch(() => {
                this.saveLoading = false
              })
          }
        }
      })
    },
    covertTime2Date(time) {
      if (time) {
        return moment(time)
      }
    },
    success(id) {
      this.$message.info(this.$t('page_resource_pool_success'))
      this.$emit('closeModal', true, !this.isEdit && !this.addFlag, id)
    },
    covertTime2String(time) {
      if (time && typeof time !== 'string') {
        return time.format('YYYY-MM-DD')
      }
    },
    sendWpData(data) {
      this.workProcedureList = data
    },
    chooseSort(index) {
      this.chooseIndex = index
    },
    getEditCol(editCol) {
      this.editCol = editCol
    },
    async getProductInfoList($event) {
      if (this.category === 1) {
        const res = await productServiceProxy.getFixedBoardList($event.value)
        this.productList = res
        this.productListForm = res.map((item) => {
          return {
            label: item.code +'—'+item.name,
            value: item.code
          }
        })
      } else {
        const res = await productServiceProxy.getWithTypeIdList($event.value)
        this.productList = res
        this.productListForm = res.map((item) => {
          return {
            label: item.code +'—'+item.name,
            value: item.code
          }
        })
      }
      console.log(this.schema,'mmcodename')

      if(this.addFlag || this.isEdit) { // 编辑或追加时不展示产品信息
        this.schema = {
          ...this.schema,
          properties: {
            ...this.schema.properties,
            productCode: {
              ...this.schema.properties.productCode,
              readOnly: this.addFlag || this.isEdit, // false,
              enum: this.productListForm
            }
          }
        }
      } else {
        this.schema = {
          ...this.schema,
          properties: {
            ...this.schema.properties,
            productCode: {
              ...this.schema.properties.productCode,
              readOnly: this.addFlag || this.isEdit, // false,
              enum: this.productListForm
            },
            codeAndName: {
              ...this.schema.properties.codeAndName,
              readOnly: this.addFlag || this.isEdit,
              enum: this.productListForm
            }
          }
        }
      }
      //处理编辑计划的时候多一列空白的问题
      // if(this.isEdit){
      //   delete this.schema.properties.codeAndName
      // }
    },
    async selectChange($event) {
      console.log(11, $event)
      const { form } = this.$refs.dForm
      if ($event.key === 'codeRuleId') {
        if ($event.value) {
          form.setFieldsValue({ ['code']: '' })
          this.schema = {
            ...this.schema,
            properties: {
              ...this.schema.properties,
              code: {
                ...this.schema.properties.code,
                readOnly: true
              }
            }
          }
        } else {
          this.schema = {
            ...this.schema,
            properties: {
              ...this.schema.properties,
              code: {
                ...this.schema.properties.code,
                readOnly: false
              }
            }
          }
        }
      }
      if($event.key === 'codeAndName') {
        if($event.value) {
          this.productList.map(item => {
             if($event.value === item.code) {
               this.schema = {
                ...this.schema,
                properties: {
                  ...this.schema.properties,
                  productCode: {
                    ...this.schema.properties.productCode,
                    default: item.code,
                    value: item.code,
                    readOnly: true
                  },
                  productName: {
                    ...this.schema.properties.productName,
                    default: item.name,
                    value: item.code,
                  }
                }
              }
             }
          })
          console.log(222, this.schema)
        }
      }
      if ($event.key === 'productTypeName') {
        form.setFieldsValue({ ['codeAndName']: '' })
        form.setFieldsValue({ ['productCode']: '' })
        form.setFieldsValue({ ['productName']: '' })

        if ($event.value) {
          this.getProductInfoList($event)
        } else {
          this.schema = {
            ...this.schema,
            properties: {
              ...this.schema.properties,
              productCode: {
                ...this.schema.properties.productCode,
                readOnly: true
              }
            }
          }
        }
      }

      if ($event.key === 'codeAndName') {
        const product = this.productList.find((res) => res.code === $event.value) || {}
        console.log(22222, product)
        form.setFieldsValue({
          materialCode: product.materialCode,
          standardModel: product.standardModel,
          productCode: product.code,
          productName: product.name
        })
        if(this.category===1){
          form.setFieldsValue({
          craftVersion: null
          })
          this.getCraftListByProductId(product.id)
        }


      } else if ($event.key === 'craftVersion') {
        const craftVersion = this.craftList.find((res) => res.version === $event.value) || {}
        form.setFieldsValue({
          bomVersion: null
        })
        this.getBomVersionByCraftId(craftVersion.id)
      }

    },
    radioChange($event) {
      this.category = $event.e.target.value
      const { form } = this.$refs.dForm
      form.setFieldsValue({ "codeAndName":null })
      form.setFieldsValue({'productTypeName': null})
      this.initSchema()
    },
    getCraftListByProductId(productId) {
      productionCraftServiceProxy.getProductCraftRemark(productId).then((res) => {
        this.craftList = res.filter((re) => re.editionStatus === 2)
        this.formCraftList = this.craftList.map((re) => {
          return {
            label: re.remark,
            value: re.version
          }
        })
        this.schema = {
          ...this.schema,
          properties: {
            ...this.schema.properties,
            craftVersion: {
              ...this.schema.properties.craftVersion,
              enum: this.formCraftList
            }
          }
        }
      })
    },
    // 工艺文档
    openDocModal() {
      this.docModalVisible = true
    },
    // 关闭工艺文档上传弹出框，重新加载程序列表
    closeDocModal(fileList) {
      this.docModalVisible = false
      if (fileList && fileList.length > 0) {
        // 根据资源id查询文件列表
        this.fileList = []
        this.fileList4NewIncomming = fileList
        fileList.forEach((res) => {
          this.fileList.push({
            fileId: res.objectKey,
            fileName: res.displayName
          })
        })
      }
    },
    getBomVersionByCraftId(craftId) {
      bomVersionServiceProxy.getBomVersionByCraftId(craftId).then((res) => {
        this.bomVersionList = res
        this.formBomVersionList = this.bomVersionList.map((re) => {
          return {
            label: re.version,
            value: re.version
          }
        })
        this.schema = {
          ...this.schema,
          properties: {
            ...this.schema.properties,
            bomVersion: {
              ...this.schema.properties.bomVersion,
              enum: this.formBomVersionList
            }
          }
        }
      })
    },

  },
  watch:{
    category:{
      handler(val){
      if(val === 1&&this.isEdit===false){
        console.log('111')
        productServiceProxy
        .getFixedBoardList(this.productTypeList[0].value)
        .then((res) => {
          this.productList = res
          this.productListForm = res.map((item) => {
            return {
              label: item.code +'—'+ item.name,
              value: item.code
            }
          })
          if (this.formData.productId) {
            this.getCraftListByProductId(this.formData.productId)
          }
          if (this.formData.craftId) {
            this.getBomVersionByCraftId(this.formData.craftId)
          }
        })
      }else if(val === 2&&this.isEdit===false){
         productServiceProxy
         .getWithTypeIdList(this.productTypeList[0].value)
         .then((res) => {
           this.productList = res
           this.productListForm = res.map((item) => {
             return {
               label: item.code +'—'+ item.name,
               value: item.code
             }
           })
         })
      }
      },
      deep: true,
    }}
})
